var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"I1Btn",style:({top:_vm.y + 'px',left:_vm.x+'px'}),on:{"click":_vm.selectBtn}})}
var staticRenderFns = []

export { render, staticRenderFns }